/**
 * Validación compartida de Mux playback IDs (admin dual-CTA, premium invite, API).
 * Formato: 10–255 chars, alfanumérico + guión/underscore (policy public en Mux).
 */
export function isValidMuxPlaybackId(id: unknown): id is string {
  if (typeof id !== "string" || !id.trim()) return false;
  const s = id.trim();
  return /^[a-zA-Z0-9_-]+$/.test(s) && s.length >= 10 && s.length <= 255;
}
